// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"Loader_loading-wrapper__GeSll","loading-icon":"Loader_loading-icon__sDACS"};